import React, { useState, useEffect } from "react";
import axios from "axios";
import StudentLeftside from "./StudentLeftside";
import "./MasterQuizList.css";
import API_BASE_URL from "../config/api";

const SubscriptionList = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterText, setFilterText] = useState("");
  const [panelOpen, setPanelOpen] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);

  const pageSize = 5;

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userId = user?.id;

    if (!userId) {
      console.error("User not logged in");
      setLoading(false);
      return;
    }

    // POST request to match your PHP API
    axios
      .post(`${API_BASE_URL}/get_user_subscriptions.php`, { user_id: userId })
      .then((res) => {
        if (res.data.success) {
          setSubscriptions(res.data.subscriptions || []);
        } else {
          console.error("Failed to fetch subscriptions:", res.data.message);
          setSubscriptions([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching subscriptions:", err);
        setSubscriptions([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const filteredSubscriptions = subscriptions.filter((sub) => {
    const filter = filterText.toLowerCase();
    return (
      (sub.purchase_id?.toString().toLowerCase().includes(filter) ?? false) ||
      (sub.plan_name?.toLowerCase().includes(filter) ?? false) ||
      (sub.package_type?.toLowerCase().includes(filter) ?? false) ||
      (sub.status?.toLowerCase().includes(filter) ?? false)
    );
  });

  const totalPages = Math.ceil(filteredSubscriptions.length / pageSize) || 1;
  const start = (currentPage - 1) * pageSize;
  const displayed = filteredSubscriptions.slice(start, start + pageSize);

  const handleView = (sub) => {
    setSelectedSubscription(sub);
    setPanelOpen(true);
  };

  const closePanel = () => {
    setPanelOpen(false);
    setTimeout(() => setSelectedSubscription(null), 300);
  };

  return (
    <div className="dashboard-wrap bg-light min-h-screen flex">
      <StudentLeftside />
      <main className="dashboard-content container-fluid py-2 flex-1 position-relative">
        <div className="quiz-section mb-5">
          <div className="quiz-header d-flex justify-content-between align-items-center mb-2">
            <h3 className="quiz-title">Transaction</h3>
            <input
              type="text"
              placeholder="Filter"
              value={filterText}
              onChange={(e) => {
                setFilterText(e.target.value);
                setCurrentPage(1);
              }}
              className="quiz-filter form-control w-auto"
            />
          </div>

          <div className="table-responsive">
            {loading ? (
              <p className="text-center py-4">Loading subscriptions...</p>
            ) : (
              <table className="table table-bordered table-striped align-middle text-center">
                <thead className="table-primary">
                  <tr>
                    <th>No.</th>
                    <th>Plan Name</th>
                    <th>Plan Type</th>
                    <th>Purchase Date</th>
                    <th>Expiry Date</th>
                    <th>Status</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {displayed.length > 0 ? (
                    displayed.map((sub, index) => (
                      <tr key={sub.purchase_id || index}>
                        <td>{start + index + 1}</td>
                        <td>{sub.plan_name}</td>
                        <td>{sub.package_type}</td>
                        <td>{sub.purchase_date}</td>
                        <td>{sub.expiry_date}</td>
                        <td>{sub.status}</td>
                        <td>{sub.plan_price}</td>
                        <td>
                          <button
                            className="btn btn-link p-0"
                            onClick={() => handleView(sub)}
                            aria-label={`View details for subscription ${sub.purchase_id}`}
                          >
                            <i className="bi bi-eye fs-5 text-primary"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-muted py-3">
                        No subscriptions found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          <div className="quiz-pagination d-flex justify-content-between align-items-center mt-2">
            <div>
              Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
            </div>
            <div>
              <button
                className="btn btn-outline-secondary btn-sm me-1"
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
              >
                ⏮ First
              </button>
              <button
                className="btn btn-outline-secondary btn-sm me-1"
                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
              >
                ◀ Prev
              </button>
              <button
                className="btn btn-outline-secondary btn-sm me-1"
                onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
              >
                Next ▶
              </button>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
              >
                Last ⏭
              </button>
            </div>
          </div>
        </div>

        {selectedSubscription && (
          <section>
          <div className={`subscription-panel-right ${panelOpen ? "open" : "close"}`}>
            <div className="panel-header">
              <h5 className="m-0">Subscription Details</h5>
              <button
                className="btn-close"
                onClick={closePanel}
                aria-label="Close subscription details panel"
              >
                ×
              </button>
            </div>
            <div className="panel-body mt-3">
              <p><strong>Purchase ID:</strong> {selectedSubscription.purchase_id}</p>
              <p><strong>Plan ID:</strong> {selectedSubscription.plan_id}</p>
              <p><strong>Plan Name:</strong> {selectedSubscription.plan_name}</p>
              <p><strong>Plan Type:</strong> {selectedSubscription.plan_type}</p>
              <p><strong>Purchase Date:</strong> {selectedSubscription.purchase_date}</p>
              <p><strong>Expiry Date:</strong> {selectedSubscription.expiry_date}</p>
              <p><strong>Status:</strong> {selectedSubscription.status}</p>
              <p><strong>Price:</strong> {selectedSubscription.subscription_price}</p>
            </div>
          </div>
          </section>
        )}
      </main>
    </div>
  );
};

export default SubscriptionList;
